import type { IAppsAndroidFiltersDto, IAppsIosFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";
import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { FindAppsRowDto, IFindAppsPaginationParamsDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";
import type { IFindAppsRequestState, IFindAppsState } from "app/pages/sales-intelligence/store/find-apps/types/state";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 50;

const DEFAULT_ORDER_BY_COLUMN: keyof FindAppsRowDto = "number_of_ratings";

export const DEFAULT_INITIAL_PAGINATION: IFindAppsPaginationParamsDto = {
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
};

const DEFAULT_INITIAL_VALUES: IFindAppsRequestState<IAppsIosFiltersDto & IAppsAndroidFiltersDto> = {
    ...DEFAULT_INITIAL_PAGINATION,
    searchText: "",
    filters: {},
};

export const initialFindAppsState: IFindAppsState = {
    activeAppSourceType: AppsSourceType.GoogleStore,
    isRowSelectionEnabled: false,
    selectedRows: [],

    [AppsSourceType.GoogleStore]: {
        expandedFilter: null,
        request: {
            ...DEFAULT_INITIAL_VALUES,
            orderBy: DEFAULT_ORDER_BY_COLUMN,
            asc: false,
        },
    },
    [AppsSourceType.AppleStore]: {
        expandedFilter: null,
        request: {
            ...DEFAULT_INITIAL_VALUES,
            orderBy: DEFAULT_ORDER_BY_COLUMN,
            asc: false,
        },
    },
};
